import React, { useState } from 'react';

import {
  ProjectCard,
  ProjectImg,
  ProjectsContainer,
  ProjectsContent,
  ProjectsH1,
  ProjectTitle,
  ProjectsWrapper,
  IframeContainer,
  VideosGridWrapper,
} from './ProjectsElements';
import ProjectModal from './ProjectModal/ProjectModal';
import { PROJECTS, YOUTUBE_VIDEOS } from './constants';

const Projects = () => {
  const [currentProject, setCurrentProject] = useState(null);

  const handleProjectModalClose = () => {
    setCurrentProject(null);
  };

  const handleProjectModalOpen = (project) => {
    setCurrentProject(project);
  };

  return (
    <ProjectsContainer id="projects">
      <ProjectsWrapper>
        <ProjectsH1>Projects</ProjectsH1>
        <ProjectsContent>
          {PROJECTS.map((project) => (
            <ProjectCard onClick={() => handleProjectModalOpen(project)}>
              <ProjectImg src={project.images[0]} alt={project.displayTitle} />
              <ProjectTitle>{project.displayTitle}</ProjectTitle>
            </ProjectCard>
          ))}
        </ProjectsContent>

        {currentProject ? (
          <ProjectModal
            project={currentProject}
            onClose={handleProjectModalClose}
          />
        ) : null}

        <VideosGridWrapper>
          {YOUTUBE_VIDEOS.map(({ videoEmbedUrl, title }) => (
            <IframeContainer>
              <iframe
                width="560"
                height="315"
                src={videoEmbedUrl}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                frameBorder={0}
              />
            </IframeContainer>
          ))}
        </VideosGridWrapper>
      </ProjectsWrapper>
    </ProjectsContainer>
  );
};

export default Projects;
